<template>
  <div>
    <transition name="fade">
      <div class="container text-center mb-5">

        <h3
          v-if="noEnterprisesFound"
          class="text-uppercase"
        >
          Não encontramos nada relacionado...
        </h3>

        <h3
          v-else-if="countProperties >= 1 && !loading"
          class="text-uppercase"
        >
          Encontramos {{ countProperties }} {{ countProperties > 1 ? 'empreendimentos' : 'empreendimento' }}
        </h3>

        <h3
          v-else-if="loading"
          class="mb-5 pb-4 pt-2 mt-5 text-uppercase"
        >
          Buscando os melhores resultados...
        </h3>

        <p
          v-if="noEnterprisesFound"
          class="subtitle-result"
        >
          Procurando algo específico?
        </p>

        <p
          v-else-if="countProperties >= 1 && !loading"
          class="subtitle-result"
        >
          Confira agora as melhores opções em empreendimentos habitacionais de alta qualidade e tecnologia construtiva, voltados para o programa Minha Casa Minha Vida, com condições especiais para você.
        </p>

      </div>
    </transition>
    <transition name="fade">
      <div class="container" v-if="!loading">
        <div class="row">
          <div
            class="col-12 col-sm-6 col-xl-4 d-flex align-items-stretch"
            v-for="card in displayedCards"
            :key="card.id"
          >
            <a
              :href="card.epw_link"
              target="_blank"
              class="card card-insta"
            >
              <div class="card-header">
                <div class="link-obj">
                  <span class="hot" v-if="card.launch">Lançamento</span>
                  <img
                    :src="'data:image.png;base64,' + card.imagem"
                    class="card-img-top"
                    :alt="card.titulo"
                    @error="renderDefaultImage"
                  />
                  <span class="read-more-bar">
                    Saiba mais
                    <i class="material-icons">chevron_right</i>
                  </span>
                </div>
              </div>
              <div class="card-body pb-2">
                <span class="card-locale">{{ card.cidade.descricao }}/{{ card.uf.descricao }}</span>
                <h5 class="card-title my-1" v-if="card.titulo">{{ card.titulo }}</h5>
                <span class="card-phase">{{ card.fase.descricao }}</span>
                <p class="card-text mt-3" v-if="card.subTitulo">
                  <span>{{ card.subTitulo }}</span>
                  <br />
                </p>
                <p class="card-text" v-if="card.descricao">{{ card.descricao }}</p>
              </div>
              <div class="card-footer">
                <div class="features vertical">
                  <div class="row">
                    <div class="col-6 mb-3" v-if="card.metragem.codigo">
                      <i class="material-icons">straighten</i>
                      <small>{{ card.metragem.descricao }} m²</small>
                    </div>
                    <div class="col-6 mb-3" v-if="card.qtdDormitorios.codigo">
                      <i class="material-icons">hotel</i>
                      <small>{{ card.qtdDormitorios.descricao }} dorms.</small>
                    </div>
                    <div class="col-6 mb-3" v-if="card.qtdSuites.codigo">
                      <i class="material-icons">bathtub</i>
                      <small>{{ card.qtdSuites.descricao }} suítes</small>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <section id="content-pagination" class="container-fluid">
          <div class="row" v-if="countProperties > cardsPerPage">
            <!-- begin::row-pagination -->
            <div class="col-12">
              <nav>
                <ul class="pagination ml-auto">
                  <li class="page-item">
                    <a @click="pageNumber >= 2 ? pageNumber-- : false" class="page-link">
                      <i class="material-icons">chevron_left</i>
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="(pagination, index) in displayedPaginations"
                    :key="index"
                  >
                    <a
                      @click="pageNumber = index + 1"
                      :class="index + 1 == pageNumber ? 'page-link active-page' : 'page-link'"
                    >{{ index + 1}}</a>
                  </li>
                  <li class="page-item">
                    <a
                      @click="(pageNumber <= countProperties / cardsPerPage) ? pageNumber++ : false"
                      class="page-link"
                    >
                      <i class="material-icons">chevron_right</i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <!-- end::row-pagination -->
        </section>
      </div>
    </transition>
    <div class="container" v-if="loading">
      <div class="row">
        <div
          class="col-12 col-sm-6 col-xl-4 d-flex align-items-stretch"
          v-for="index in cardsPerPage"
          :key="index"
        >
          <div class="placeload">
            <div class="header">
              <div class="img loads"></div>
              <div class="header-content">
                <div class="content-shape loads"></div>
                <div class="content-shape loads"></div>
              </div>
            </div>
            <div class="body-content">
              <div class="content-shape loads"></div>
              <div class="content-shape loads"></div>
              <div class="content-shape loads"></div>
            </div>
            <div class="placeholder-footer">
              <div class="footer-block">
                <div class="content-shape loads"></div>
                <div class="content-shape loads"></div>
                <div class="content-shape loads"></div>
                <div class="content-shape loads"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios"
import EventBus from '@/event-bus'

export default {

  name: "cards",

  data: function() {

    return {
      pageNumber: 1,
      cardsPerPage: 10,
      noEnterprisesFound: false
    }

  },

  mounted() {

    EventBus.$on('noEnterprisesFound', state => this.noEnterprisesFound = state)

  },

  methods: {

    renderDefaultImage(event) {

      event.target.src = 'https://imoveis.zmaisconstrutora.com.br/static/z-inc-default.jpg'

    },

    paginate(cards) {

      let from = this.pageNumber * this.cardsPerPage - this.cardsPerPage;
      let to = this.pageNumber * this.cardsPerPage;

      return cards.slice(from, to);

    }

  },

  computed: {

    countProperties() {
      return this.cards.length;
    },

    displayedCards() {
      return this.paginate(this.cards);
    },

    displayedPaginations() {

      return this.cards.slice(
        0,
        Math.ceil(this.countProperties / this.cardsPerPage)
      )

    }

  },

  watch: {
    cards(value) {
      // Ever on change cards, pagination return to 1
      this.pageNumber = 1;
    }
  },

  props: {
    cards: { type: Array, default: [] },
    loading: { type: Boolean, default: true }
  }

};
</script>

<style lang="less">
.subtitle-result {
  color: #808080;
}
#content-pagination {
  width: 100%;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  .page-item {
    cursor: pointer;
    user-select: none;
    width: 36px;
    height: 36px;
    .page-link {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.active-page {
  background: #0d7658;
  color: #ffffff !important;
  &:hover {
    background: #231F20;
  }
}

.card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
  width: 100%;
  .card-header {
    padding: 0;
    &:first-child {
      border-radius: 0;
    }
    .link-obj {
      position: relative;
      display: block;
      text-decoration: none;
    }
    .card-img-top {
      border-radius: 0;
      min-height: 200px;
    }
  }
  .card-body {
    .card-locale {
      font-size: 1rem;
      color: #0d7658;
    }
    .card-title {
      font-size: 1.25rem;
      color: #111111;
    }
    .card-phase {
      font-size: 1rem;
      color: #0d7658;
    }
    .card-text {
      font-size: 0.9rem;
      color: #444444;
      span {
        color: #838383;
        font-size: 0.85rem;
      }
    }
  }
  .card-footer {
    background-color: #fff;
    border-top: 0;
    .features.vertical {
      text-align: left;
      height: 72px;
      .col-6 {
        display: flex;
        align-items: center;
        small {
          font-size: 0.75rem;
          color: #444444;
        }
      }
      i {
        margin-right: 5px;
        color: #0d7658;
      }
    }
  }
}

/* begin::responsive */
@media (min-width: 1440px) {
  .container:not(nav) {
    max-width: 1400px;
  }
}

@media (min-width: 576px) {
  .col-cards {
    padding: 0 0.25rem;
  }
}
/* end::responsive */

.card .price p {
  font-size: 0.9rem;
  margin-bottom: 0.2rem;
  line-height: 1.2rem;
  color: #666;
}
.card .price p small {
  font-size: 0.8rem;
}

.card .features {
  text-align: center;
}

.card .features i {
  font-size: 20px;
}

.card .features .d-block {
  word-wrap: initial;
  font-size: 12px;
  line-height: 14px;
}
.card-insta {
  border-radius: 0;
  border: 0;
  transition: all 0.3s;
}

.card-insta img {
  opacity: 0.9;
  transition: all 0.3s;
}

.card-insta .hot {
  position: absolute;
  padding: 0.3125rem 0.625rem;
  display: inline-block;
  top: 10px;
  left: 10px;
  background: red;
  color: #fff;
  font-size: 0.8rem;
  z-index: 2;
}

.read-more-bar {
  display: flex;
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  background: #0d7658;
  color: #fff;
  transition: all 0.3s;
}

.card-insta {
  font-size: 0.9rem;
}
.card-insta:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  text-decoration: none;
}

.card-insta:hover img {
  opacity: 1;
}

.card-insta:hover .read-more-bar {
  background: #000;
  color: #fff;
}

.floater-tags {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  z-index: 10;
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
}

.floater-tags-content {
  background: #fafafa;
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 12px;
  display: flex;
  align-content: center;
  margin: 0 10px 10px 0;
  color: #333;
  border: #ccc solid 1px;
}

.floater-tags-content i {
  margin-right: 3px;
  font-size: 18px;
}

.fixed {
  position: fixed;
  top: 150px;
}

.chip {
  display: inline-block;
  height: 32px;
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  line-height: 32px;
  padding: 0 0 0 12px;
  -webkit-border-radius: 16px;
  border-radius: 16px;
  background-color: #e4e4e4;
  margin-right: 5px;
}

.chip i {
  cursor: pointer;
  float: right;
  font-size: 16px;
  line-height: 32px;
  padding-left: 8px;
  width: 32px;
  background: #ccc;
  margin-left: 10px;
  border-radius: 50%;
}

.FilterResultContainer {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  padding-top: 8px;
}
.FilterResult__container__list {
  margin: 0 8px 8px 0;
  display: flex;
}

.FilterResult__container__list__item {
  font-size: 14px;
  color: #2e2e37;
  border-radius: 8px;
  border: 1px solid #2e2e37;
  padding: 0 12px;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  height: 23px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: baseline;
  -webkit-align-items: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
}

/* begin::card placeholders */
.placeload {
  background: #fff;
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
  padding: 0px;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  animation: opacityDelay 1s;
}
.placeload .header .img {
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
}
.placeload .header .header-content {
  padding: 0 20px;
}
.placeload .header .header-content .content-shape {
  margin: 0;
  height: 14px;
}
.placeload .header .header-content .content-shape:first-child {
  width: 100%;
  height: 20px;
  margin-bottom: 8px;
}
.placeload .header .header-content .content-shape:nth-child(2) {
  width: 80%;
  margin-bottom: 30px;
}
.placeload .header .header-content .content-shape:nth-child(3) {
  width: 90%;
}
.body-content {
  padding: 0 20px 20px;
}
.body-content .content-shape {
  margin: 0;
  height: 14px;
  margin-bottom: 8px;
}

.placeholder-footer {
  position: relative;
  padding: 0px 20px 20px;
}
.placeholder-footer .footer-block {
  width: 100%;
  height: 100%;
  min-height: 20px;
}
.placeholder-footer .footer-block .content-shape {
  height: 8px;
  margin-bottom: 8px;
  width: 50%;
  float: left;
  margin-right: 4%;
}
.placeholder-footer .footer-block .content-shape:first-child {
  width: 48%;
}
.placeholder-footer .footer-block .content-shape:nth-child(2) {
  width: 48%;
  margin-right: 0;
}
.placeholder-footer .footer-block .content-shape:nth-child(3) {
  width: 48%;
}
.placeholder-footer .footer-block .content-shape:nth-child(4) {
  width: 48%;
  margin-right: 0;
}

.loads {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeload;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: #eeeeee;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  -webkit-background-size: 800px 104px;
  background-size: 1200px 104px;
  position: relative;
}

@-webkit-keyframes placeload {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

@-webkit-keyframes opacityDelay {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes placeload {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
/* end::card placeholders */

/* begin::transition */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/* end::transition */
</style>



// WEBPACK FOOTER //
// src/components/Cards.vue